import React, { FC, useContext, useRef, useState } from 'react';
import Cookies from 'js-cookie';
import CalendarHeader from '@components/jobs/bigCalendar/calendarHeader';
import JobPostPopUp from '@components/jobs/bigCalendar/jobPostPopUp';
import styles from '@components/jobs/jobs.module.scss';
import { LatestOpenType } from '@components/jobs';
import LoginModal from '@components/loginModal';
import JobPostCalendar from '@components/jobs/bigCalendar/jobPostCalendar';
import { CalendarContext, BigCalendarContext } from '@components/jobs/contextWrap';
import { useBookmark } from '@components/jobs/bigCalendar/hook';
import { useCalendarFilter, useCalendarPcList } from '@repository/calendar/useCalendar';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { CalendarFilterFormVO } from '@domain/vo/calendar/CalendarFilterFormVO';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface BigCalendarProps {
  isFocusDate: boolean;
  setLatestOpen: (type: LatestOpenType) => void;
  setIsFocusDate: (focus: boolean) => void;
}

const BigCalendar: FC<BigCalendarProps> = ({ setIsFocusDate, setLatestOpen, isFocusDate }) => {
  const { filter } = useContext(CalendarContext);
  const { jobPostPopup } = useContext(BigCalendarContext);

  //로그인 모달
  const [loginModalVisible, setLoginModalVisible] = useState(false);

  //공고 팝업이 열릴 위치 정보
  const calendarInnerRef = useRef<HTMLDivElement>(null);

  //유저정보 조회
  const { data: userData, isFetched: isFetchedUserInfo } = useUserInfo();
  //유저정보 조회 enabled값
  const enabledUserInfo = !!Cookies.get('accessToken');
  const isLogin = !!userData?.id;

  //캘린더 필터 데이터 조회
  const { isFetched: isFetchedFilter } = useCalendarFilter(isLogin, (vo) =>
    filter.setLatestFilter(new CalendarFilterFormVO(vo)),
  );

  //로그인 안했으면 바로 호출, 로그인 했으면 필터값 가져와야 api호출
  const enableFetchCalendarList = !enabledUserInfo || (isFetchedUserInfo && (isLogin ? isFetchedFilter : true));
  //캘린더 데이터 호출
  const { data: calendarData } = useCalendarPcList(filter.latestFilter, enableFetchCalendarList);
  //공용으로 사용할 공고 북마크 상태
  const { jobPostingBookmarkMap, updateBookmarkStatus } = useBookmark(calendarData?.jobPostingBookmarkMap);

  if (!calendarData) return null;

  return (
    <div className={cx('calendarInner')} ref={calendarInnerRef}>
      {/* 상단 고정 영역 */}
      <CalendarHeader
        setIsFocusDate={setIsFocusDate}
        setLoginModalVisible={setLoginModalVisible}
        setLatestOpen={setLatestOpen}
      />
      {/* 캘린더 영역 */}
      <JobPostCalendar
        calendarInnerRef={calendarInnerRef}
        calendarData={calendarData}
        isFocusDate={isFocusDate}
        setLatestOpen={setLatestOpen}
        updateBookmarkStatus={updateBookmarkStatus}
      />

      {jobPostPopup.jobPostPopUpData && (
        <JobPostPopUp
          calendarData={calendarData}
          setLatestOpen={setLatestOpen}
          openLoginModal={() => setLoginModalVisible(true)}
          jobPostingBookmarkMap={jobPostingBookmarkMap}
          updateBookmarkStatus={updateBookmarkStatus}
        />
      )}
      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={loginModalVisible}
        onClose={() => setLoginModalVisible(false)}
      />
    </div>
  );
};

export default BigCalendar;
